import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from '../../models/menu-item.model';

@Component({
  selector: 'app-vertical-menu-item',
  imports: [],
  templateUrl: './vertical-menu-item.component.html',
  styleUrl: './vertical-menu-item.component.scss'
})
export class VerticalMenuItemComponent {
  @Input({ required: true }) item!: MenuItem;
  @Input() activePath = '';

  constructor(private readonly router: Router) {}

  protected onItemClick(event: Event): void {
    if (this.item.disabled) {
      event.preventDefault();
      return;
    }

    const href = this.item.href;
    if (!href || href === '#') {
      event.preventDefault();
      return;
    }

    if (href.startsWith('/')) {
      event.preventDefault();
      void this.router.navigateByUrl(href);
    }
  }

  protected isActive(): boolean {
    // Actif si l'URL commence par le href du menu (pour supporter les params/query)
    const normalize = (url: string) => url.split('?')[0].replace(/\/$/, '');
    return normalize(this.activePath) === normalize(this.item.href) || normalize(this.activePath).startsWith(normalize(this.item.href));
  }
}
